/* Значки экранов инструментов, которых нет в StudioIcon (общий файл студии другой зоны).
   Пути — дословно из набора SteosUI.icons (vendor/widgets-shared/steos-ui.js); остальное отдаёт StudioIcon. */
import { StudioIcon } from '../StudioIcon';

const EXTRA: Record<string, string[]> = {
  download: ['M12 4v12m0 0 4-4m-4 4-4-4M4 17v2a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-2'],
  upload: ['M12 16V4m0 0-4 4m4-4 4 4M4 16v3a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-3'],
  refresh: ['M20 12a8 8 0 1 1-2.3-5.7M20 4v5h-5'],
  shield: ['M12 3 4 6v6c0 5 3.5 8 8 9 4.5-1 8-4 8-9V6z'],
  warn: ['M12 9v4m0 4h.01M10.3 3.9 1.8 18a2 2 0 0 0 1.7 3h17a2 2 0 0 0 1.7-3L13.7 3.9a2 2 0 0 0-3.4 0z'],
  copy: ['M5 15V6a2 2 0 0 1 2-2h9'],
  link: [
    'M10 14a4 4 0 0 0 5.7 0l3-3a4 4 0 0 0-5.7-5.7l-1 1M14 10a4 4 0 0 0-5.7 0l-3 3a4 4 0 0 0 5.7 5.7l1-1',
  ],
  trash: ['M4 7h16M10 11v6m4-6v6M6 7l1 13h10l1-13M9 7V4h6v3'],
  clock: ['M12 7v5l3 2'],
  info: ['M12 11v5m0-8h.01'],
  more: [],
  stop: [],
  pause: [],
  scissors: ['M8.1 8.1 20 20M14.5 9.5 20 4M8.1 15.9l3.4-3.4'],
};
const EXTRA_SHAPES: Record<string, Array<{ circle?: [number, number, number]; rect?: [number, number, number, number, number] }>> = {
  copy: [{ rect: [9, 9, 11, 11, 2] }],
  clock: [{ circle: [12, 12, 9] }],
  info: [{ circle: [12, 12, 9] }],
  more: [{ circle: [6, 12, 1.8] }, { circle: [12, 12, 1.8] }, { circle: [18, 12, 1.8] }],
  stop: [{ rect: [6, 6, 12, 12, 3] }],
  scissors: [{ circle: [6, 6, 3] }, { circle: [6, 18, 3] }],
};
export function ToolIcon({ kind, size = 16 }: { kind?: string; size?: number }) {
  if (kind === 'pause')
    return (
      <svg viewBox="0 0 24 24" width={size} height={size} aria-hidden="true">
        <path d="M7 5h3v14H7zM14 5h3v14h-3z" fill="currentColor" />
      </svg>
    );
  if (!kind || !(kind in EXTRA)) return <StudioIcon kind={kind} />;
  const filled = kind === 'more';
  return (
    <svg
      viewBox="0 0 24 24"
      width={size}
      height={size}
      fill={filled ? 'currentColor' : 'none'}
      stroke={filled ? 'none' : 'currentColor'}
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      {(EXTRA_SHAPES[kind] ?? []).map((shape, index) =>
        shape.circle ? (
          <circle key={`c${index}`} cx={shape.circle[0]} cy={shape.circle[1]} r={shape.circle[2]} />
        ) : shape.rect ? (
          <rect key={`r${index}`} x={shape.rect[0]} y={shape.rect[1]} width={shape.rect[2]} height={shape.rect[3]} rx={shape.rect[4]} />
        ) : null,
      )}
      {EXTRA[kind].map((d, index) => (
        <path key={index} d={d} />
      ))}
    </svg>
  );
}
